import { useSyncExternalStore } from 'react';

/**
 * Whether the docked side chat opens OVER the content instead of pushing it aside.
 *
 * The docked chat is a fixed column at the inline end (`FloatingChat`), and by default the content pane makes
 * room for it (AppFrame's `--chat-w`). A screen that is a canvas rather than a page — the home's activity-map
 * canvas — would rather keep its width: pushed, its map, dock and player all slide and squeeze; overlaid,
 * they stay put and the chat sits on top. Such a screen raises this for as long as it is mounted.
 *
 * A store rather than a context because AppFrame, which spends it, is not inside the screen that raises it.
 */
let over = false;
const listeners = new Set<() => void>();

export function setChatOverContent(next: boolean): void {
  if (over === next) return;
  over = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useChatOverContent(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => over,
    () => false,
  );
}
